
<!--

IMPORTACAO DE XML DA DI




FALTA:
- TESTE DE EXCLUSAO DA DI
- GERAR PDF DA DANFE DA NF ANTES DA AUTORIZACAO (nfimport-list.handlePreviewPDF)
- ABRIR VALOR E BASE DO ICMS NOS ITENS PARA CORRECAO DE DIFERENÇAS QUANDO OCORRER
- ABRIR TIPO DE RATEIO PARA AS TAXAS (por peso da adicao, por valor do produto, por adicao, volume)


-->

<script>
import { SysVars } from '../main';
import { arr, calcDesconto } from '../shared/numbers'
import { getText, formatDate, formatValue } from '../shared/utils'
import { apiORDSpost, apiORDSdelete, apiAutNFe } from '../shared/api-functions'
import nfimportAdicaoForm from './nfimport-adicao-form'
import nfimportIcmsForm from './nfimport-icms-form'

export default {
    props: {
        params: {},
        crud: '',
    },

    components: {
        nfimportAdicaoForm, nfimportIcmsForm
    },

    data () {
        return {
            paramsAdicao: {},
            showFormAdicao: false,
            paramsIcms: {},
            showFormIcms: false,
            showFormDI: true,
            view: false,                //variavel para controle de visualizacao ou edicao
            coddi: '',
            di: {...this.$store.getters.getEntities.di},
            diit: [],  //ITENS DA DI
            diad: [],  //ADICOES DA DI
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao da DI apos a gravacao
            moreActions: [],  //botao mais acoes
            unwatch: true,
        }
    },

    computed: {
        isView: function () {
            //nao possibilita edicao da DI quando status for igual a 2 (NF EMITIDA)
            if (this.view)
              return true
            else
              return (this.di.stdi >= '2')
        },

        isDelete: function () {
            return this.crud == SysVars.crudDelete
        },

        partList: function () {
            return this.$store.getters.getPartList[0]
        },

        stdi: function () {
            return getText(this.di.stdi, this.metadata.di.stdi)
        },

        title: function () {
            if (this.crud == SysVars.crudD) {
                return 'Exclusão da DI'
            } else {
                return 'Importação da DI'
            }
        },

        nates: function () {
            if (this.di.nates && this.di.nates.length > 0) {
                return this.di.nates[0]
            } else {
                return null
            }
        },

        codnates: function () {
            return this.di.codnates
        },

        selectedNates: function () {
            return this.$store.getters.getNates
        },

        selectedItem: function () {
            return this.$store.getters.getItemList
        },

        vipi_ad: function () {
            let vipi = 0
            for (var x = 0; x < this.diad.length; x++){
                vipi = vipi + this.diad[x].vipi
            }
            return vipi
        },

        vicm_ad: function () {
            let vicm = 0
            for (var x = 0; x < this.diad.length; x++){
                vicm = vicm + this.diad[x].vicm
            }
            return vicm
        },

        vipi_it: function () {
            let vipi = 0
            for (var x = 0; x < this.diit.length; x++){
                vipi = vipi + this.diit[x].vipi
            }
            return vipi
        },

        vicm_it: function () {
            let vicm = 0
            for (var x = 0; x < this.diit.length; x++){
                vicm = vicm + this.diit[x].vicm
            }
            return vicm
        },

        valoresDeICMS: function () {
            return 'Base: ' +  formatValue(this.vicm_it,2) + ' Valor: ' + formatValue(this.vicm_it,2)
        },

        valoresDeIPI: function () {
            return 'Base: ' +  formatValue(this.vipi_it,2) + ' Valor: ' + formatValue(this.vipi_it,2)
        }

    },

    filters: {
        format: function (value, decimals) {
            return formatValue(value, decimals)
        },
    },

    methods: {
        itemChange (idx) {
            //CARREGA A UNIDADE DE MEDIDA QUANDO USUARIO ALTERAR O ITEM

            if (this.unwatch) {
                return
            }

            if (this.diit[idx].coditem != null) {
                this.changedItemIdx = idx  //GUARDA O INDEX DO ITEM QUE FOI ALTERADO
                this.$store.dispatch('loadItem', { id: this.diit[idx].coditem })
            }

        },

        updateIcmItens: function () {
            //ATUALIZA O ICMS NOS ITENS DA DI QUANDO ALTERADO O CAMPO DE % DE ICMS NA CAPA DA DI

            for (var x = 0; x < this.diad.length; x++){
                this.diad[x].aicm = this.di.aicm
            }

            for (var x = 0; x < this.diit.length; x++){
                this.diit[x].aicm = this.di.aicm
            }

        },

        updateIcmDifItens: function () {
            //ATUALIZA O ICMS NOS ITENS DA DI QUANDO ALTERADO O CAMPO DE % DE ICMS NA CAPA DA DI

            for (var x = 0; x < this.diad.length; x++){
                this.diad[x].picmdif = this.di.picmdif
            }
        },

        // unidadeItemChange (idx) {
        //     //HABILITA O CAMPO DE FATOR QUANDO ALTERADA A UNIDADE DE MEDIDA DO ITEM PARA UMA UNIDADE NAO RELACIONADA AO ITEM
        //     if (this.unwatch) {
        //         return
        //     }

        //     //SE A UNIDADE INFORMADA FOR IGUAL À UNIDADE DO ITEM
        //     if (this.diit[idx].uni == this.diit[idx].item[0].uni) {
        //         // this.nfit[idx].fator = 1
        //         // this.nfit[idx].obrigaFator = false
        //         return
        //     } else
        //     //SE NAO EXISTIR NENHUMA UNIDADE ALTERNATIVA
        //     if (!this.diit[idx].item[0].itemum.length) {
        //         // this.nfit[idx].obrigaFator = true
        //         // this.nfit[idx].fator = 0
        //         return
        //     }

        //     //PROCURA A UNIDADE INFORMADA NA UNIDADE ALTERNATIVA DO ITEM
        //     let unidadeValida = false
        //     for (let i = 0; i < this.diit[idx].item[0].itemum.length; i++) {
        //         if (this.diit[idx].item[0].itemum[i].uni == this.diit[idx].uni) {
        //             unidadeValida = true
        //             break;
        //         }
        //     }

        //     if (!unidadeValida) {
        //         this.diit[idx].fator = 0
        //         this.diit[idx].obrigaFator = true
        //     } else {
        //         this.diit[idx].obrigaFator = false
        //     }

        // },

        closeForm () {
            this.$emit('closeform')
        },

        data (value) {
            return formatDate(value)
        },

        handleDelete () {
            //BOTAO DE EXCLUSAO DA DI
            if (this.di) {
                this.apiInvoiceDelete()
            }
        },

        handleActions (action) {
            if (action == 6) {
            }

        },

        handleSalvarDados () {
            //botao salvar dados do cabecalho da DI
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.di.updateitens = true
                    this.di.updateadicao = true
                    this.apiPost(true)
                }
            })
        },

        handleCalcular () {
            this.di.updateitens = true
            this.di.updateadicao = true
            this.apiPost(false)
        },

        handleExcluir () {
            //BOTAO DE EXCLUSAO DA DI
            this.apiInvoiceDelete()
        },

        async apiInvoiceDelete () {
            //exclui a DI
            var modulo = 'invoice/di/' + this.di.coddi
            await apiORDSdelete(this.$store, modulo)
            this.$erpToastSuccess('A DI foi excluída com sucesso.')
            this.$emit('closeform')
        },

        async apiPost (closeOnSave) {
            //efetua a gravacao da DI

            this.di.diit = this.diit
            this.di.diad = this.diad
            var sendData = { di: this.di }

            const data = await apiORDSpost(this.$store, 'invoice/di/', sendData, 'put')
            if (data.items) {
              this.di = {}
              this.diit = []
              this.diad = []
              this.di = data.items[0]
              for (var x = 0; x < this.di.diit.length; x++){
                this.diit.push(this.di.diit[x])
              }
              for (var x = 0; x < this.di.diad.length; x++){
                this.diad.push(this.di.diad[x])
              }
              if (this.di.validation) {
                this.errmessages = JSON.parse(this.di.validation)
              } else {
                this.errmessages = []
              }
            }

            this.updateActions()

            if (closeOnSave) {
                if (this.di.stdi == '1') {
                    this.$erpToastSuccess('A DI foi concluída com sucesso')
                    this.closeForm()
                }
            }
        },

        editAliquotasAdicoes () {
            //EXIBE O FORMULARIO PARA EDICAO DAS ADICOES
            this.paramsAdicao.di = this.di
            this.paramsAdicao.diit = this.diit
            this.paramsAdicao.diad = this.diad
            this.showFormAdicao = true
            this.showFormDI = false
        },

        editIcms () {
            //EXIBE O FORMULARIO PARA EDICAO DE VALOR DO ICMS NOS ITENS
            this.paramsIcms.di = this.di
            this.paramsIcms.diit = this.diit
            this.paramsIcms.diad = this.diad
            this.showFormIcms = true
            this.showFormDI = false
        },

        saveAdicao () {
            //CONFIRMACAO DE ALTERACAO DAS ALIQUOTAS - ENVIA PARA O SERVIDOR PARA GRAVACAO
            this.closeFormAdicao()
            this.di.updateadicao = true
            this.di.updateitens = false
            this.apiPost(false)
        },

        saveIcms () {
            //CONFIRMACAO DE ALTERACAO DO ICMS NOS ITENS - ENVIA PARA O SERVIDOR PARA GRAVACAO
            this.closeFormIcms()
            this.di.updateadicao = false
            this.di.updateitens = false
            this.di.updateicms = true //variavel para controle de gravacao do valor de icms informado no item
            this.apiPost(false)
        },

        closeFormAdicao () {
            this.showFormAdicao = false
            this.showFormDI = true
        },

        closeFormIcms () {
            this.showFormIcms = false
            this.showFormDI = true
        },

        updateActions () {
            this.moreActions = []
            var act = {}
            // if (this.nf.stnf == '00') {
            //     act = { action: 5, label: 'Excluir NF-e' }
            //     this.moreActions.push(act)
            // }
        },

        async loadData () {
            //carrega a di para alteracao ou visualizacao
            await this.$store.dispatch('loadDi', { id: this.coddi } )

            if (this.$store.getters.getDi) {
                this.di = {...this.$store.getters.getDi[0]}
                this.diit = this.di.diit
                this.diad = this.di.diad
                if (this.di.validation) {
                    this.errmessages = JSON.parse(this.di.validation)
                } else {
                    this.errmessages = []
                }
                this.updateActions()
            }

            // if (this.nf.import_errors > 0) {
            //     this.$erpToastError('Por favor corrija os erros em destaque para esta nota fiscal')
            // }

            //HABILITAR WATCH
            var vm = this
            setTimeout(function() {
                vm.unwatch = false
            }, 1000)

        },

    },

    watch: {
        codnates: function () {
            if (this.unwatch) {
                return
            }
            if (this.di.codnates != null) {
               this.$store.dispatch('loadNates', { id: this.di.codnates })
            }
        },

        selectedNates: function () {
            //HABILITA CAMPO DE NOTA REFERENCIADA CONFORME TIPO DE NATUREZA INFORMADA (DEVOLUCAO, AJUSTE, COMPLEMENTO)
            if (this.unwatch) {
                return
            }

            this.di.nates = this.selectedNates
            //this.di.cfop = this.di.nates.cfop -- SEMPRE FORÇAR O USUARIO INFORMAR A CFOP
        },

        selectedItem: function () {
            //quando alterar um item, carrega a unidade de medida e a lista de unidades de medida
            if (this.unwatch) return
            if (!this.selectedItem.length) return

            this.diit[this.changedItemIdx].uni = this.selectedItem[0].uni
            this.diit[this.changedItemIdx].item = this.selectedItem
        },

        'di.aicm': function () {
            //MONITORA O CAMPO DE % DE ICMS DA CAPA DA DI PARA ATUALIZAR OS ITENS DA DI
            if (this.unwatch) {
                return
            }
            this.updateIcmItens()
        },

        'di.picmdif': function () {
            //MONITORA O CAMPO DE % DE ICMS DA CAPA DA DI PARA ATUALIZAR OS ITENS DA DI
            if (this.unwatch) {
                return
            }
            this.updateIcmDifItens()
        },

       'di.cfop': function () {
            //MONITORA O CAMPO CFOP DA CAPA DA DI PARA ATUALIZAR NAS ADICOES DA DI
            if (this.unwatch) {
                return
            }
            //ATUALIZA O CFOP NAS ADICOES DA DI QUANDO ALTERADO O CAMPO NA CAPA DA DI
            for (var x = 0; x < this.diad.length; x++){
                this.diad[x].cfop = this.di.cfop
            }
        },

        'di.sticm': function () {
            //MONITORA O CAMPO CFOP DA CAPA DA DI PARA ATUALIZAR NAS ADICOES DA DI
            if (this.unwatch) {
                return
            }
            //ATUALIZA O CFOP NAS ADICOES DA DI QUANDO ALTERADO O CAMPO NA CAPA DA DI
            for (var x = 0; x < this.diad.length; x++){
                this.diad[x].sticm = this.di.sticm
            }
        },

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.metadata.di.taxamoeda.validator = { required: true,  "valida-zero": true }

        //this.crudText = this.$crudText(this.crud)

        // if (this.$route.params && this.$route.params.id) {
        //     this.codpedv = this.$route.params.id
        // }
        // else
        if (this.crud == SysVars.crudInsert) {
        } else {
            this.coddi = this.params.coddi
            this.loadData()
            this.view = this.crud == SysVars.crudView || this.crud == SysVars.crudDelete
        }

        if (this.crud == SysVars.crudDelete) {
            // console.log('teste')
        }

        this.$scrollTo(0)

    }

}

</script>

<template>
    <div>

<!-- FORMULARIO DE ALTERACAO DAS ALIQUOTAS NAS ADICOES -->
        <div v-if="showFormAdicao">
            <nfimport-adicao-form :params="paramsAdicao" @save="saveAdicao" @closeform="closeFormAdicao"></nfimport-adicao-form>
        </div>

<!-- FORMULARIO DE ALTERACAO DOS VALORES DE ICMS NOS ITENS -->
        <div v-if="showFormIcms">
            <nfimport-icms-form :params="paramsIcms" @save="saveIcms" @closeform="closeFormIcms"></nfimport-icms-form>
        </div>

<!-- FORMULARIO PRINCIPAL -->
        <div v-if="showFormDI">
            <div class="nb-margin-bottom">
                <!-- BARRA SUPERIOR DE TITULOS E BOTOES -->
                <div class="row">
                    <div class="col-md-6 col-12">
                        <h4 class="def-title"> {{ title }}</h4>
                            <span v-if="di.stdi == '0'" class="lbl badge badge-orange">{{ stdi }}</span>
                            <span v-if="di.stdi == '1'" class="lbl badge badge-green">{{ stdi }}</span>
                            <span v-if="di.stdi >= '2'" class="lbl badge badge-green">{{ stdi }}</span>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="float-right">
                            <v-button label="Retornar" title="" icon="fa-arrow-left" @click="closeForm"></v-button>
                            <v-button label="Salvar" title="" icon="fa-download" :nb-btdef="true" @click="handleSalvarDados" v-if="!isView"></v-button>
                            <v-button label="Excluir" title="" icon="fa-trash" :nb-btdef="true" @click="handleExcluir" v-if="isDelete"></v-button>
                            <v-button v-show="moreActions.length > 0" label="Mais Ações" @click="handleActions" :actions="moreActions"></v-button>
                        </div>
                    </div>
                </div>

                <!-- MENSAGENS DE ERRO E VALIDACAO DA DI -->
                <validation v-if="errmessages.errmessages" title="Erros de validação" :messages="errmessages.errmessages"></validation>
                <!-- FIM MENSAGENS DE ERRO E VALIDACAO DA DI -->
            </div>

            <!-- CAPA DA DI -->
            <div class="default-container">
                <div class="row">
                    <div class="col-md-4 col-4">
                        <v-label :metadata-field="metadata.di.numerodi"></v-label><br>
                        <span class="lbl">{{ di.numerodi }}</span>
                    </div>
                    <div class="col-md-4 col-4">
                        <v-label :metadata-field="metadata.di.data"></v-label><br>
                        <span class="lbl">{{ data(di.data) }}</span>
                    </div>
                    <div class="col-md-4 col-4">
                        <v-label :metadata-field="metadata.di.datadesemb"></v-label><br>
                        <span class="lbl">{{ data(di.datadesemb) }}</span>
                    </div>
                    <div class="col-md-4 col-4">
                        <v-label :metadata-field="metadata.di.nomefornecedor"></v-label><br>
                        <span class="lbl">{{ di.nomefornecedor }}</span>
                    </div>
                </div>
                <div v-if="di.stdi == '0'" class="col">
                    <alert type="warning" title="Pendência encontrada" text="Efetue o relacionamento para os itens destacados abaixo."></alert>
                </div>
                <label-title title="Dados da DI"></label-title>
                <div class="row">
                    <form-field v-model="di.codpart" type="select2" col="4" :metadata="metadata.di.codpart" :disabled="isView"
                        name="codpart" :v-errors="errors" v-validate="metadata.di.codpart.validator"></form-field>
                    <form-field v-model="di.codnates" type="select2" col="4" :metadata="metadata.di.codnates" :disabled="isView"
                            :select2="{entity: 'nates/entrada', minlength: 0}"></form-field>
                    <form-field v-model="di.cfop" type="select2" col="4" :metadata="metadata.di.cfop" :disabled="isView"
                            :select2="{entity: 'cfop/entradas', minlength: 0}"></form-field>
                </div>
                <label-title title="Transporte"></label-title>
                <div class="row">
                    <form-field v-model="di.datadesemb" type="date" col="2" :metadata="metadata.di.datadesemb" :disabled="isView"
                        name="datadesemb" :v-errors="errors" v-validate="metadata.di.datadesemb.validator"></form-field>
                    <form-field v-model="di.dataentrada" type="date" col="2" :metadata="metadata.di.dataentrada" :disabled="isView"
                        name="dataentrada" :v-errors="errors" v-validate="metadata.di.dataentrada.validator"></form-field>
                    <form-field v-model="di.ufdesemb" type="select2" col="4" :metadata="metadata.di.ufdesemb" :disabled="isView"
                        name="ufdesemb" :v-errors="errors" v-validate="metadata.di.ufdesemb.validator"></form-field>
                    <form-field v-model="di.localdesemb" type="text" col="4" :metadata="metadata.di.localdesemb" :disabled="isView"
                        name="localdesemb" :v-errors="errors" v-validate="metadata.di.localdesemb.validator"></form-field>
                    <form-field v-model="di.viatranspdi" type="select" col="2" :metadata="metadata.di.viatranspdi" :disabled="isView"
                        name="viatranspdi" :v-errors="errors" v-validate="metadata.di.viatranspdi.validator"></form-field>
                    <form-field v-model="di.tpintermediodi" type="select" col="4" :metadata="metadata.di.tpintermediodi" :disabled="isView"
                        name="tpintermediodi" :v-errors="errors" v-validate="metadata.di.tpintermediodi.validator"></form-field>
                    <form-field v-model="di.ndraw" type="text" col="2" :metadata="metadata.di.ndraw" :disabled="isView"
                        name="ndraw" :v-errors="errors" v-validate="metadata.di.ndraw.validator"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="di.pliq" type="value" col="2" :metadata="metadata.di.pliq" :disabled="isView"
                        name="pliq" :v-errors="errors" v-validate="metadata.di.pliq.validator"></form-field>
                    <form-field v-model="di.pbru" type="value" col="2" :metadata="metadata.di.pbru" :disabled="isView"
                        name="pbru" :v-errors="errors" v-validate="metadata.di.pbru.validator"></form-field>
                    <form-field v-model="di.qtvolumes" type="value" col="2" :metadata="metadata.di.qtvolumes" :disabled="isView"
                        name="qtvolumes" :v-errors="errors" v-validate="metadata.di.qtvolumes.validator"></form-field>
                    <form-field v-model="di.volespecie" type="text" col="2" :metadata="metadata.di.volespecie" :disabled="isView"
                        name="volespecie" :v-errors="errors" v-validate="metadata.di.volespecie.validator"></form-field>
                </div>

                <label-title title="Informações Complementares"></label-title>
                <div class="row">
                    <div class="col-md-12 col-12">
                        <div class="form-group">
                            <textarea rows="5" cols="100" class="form-control form-control-sm" v-model="di.infcpl"></textarea>
                        </div>
                    </div>
                </div>

                <label-title title="Valores"></label-title>
                <div class="row">
                    <form-field v-model="di.vfob" type="value" col="2" :metadata="metadata.di.vfob" :disabled="true"></form-field>
                    <form-field v-model="di.vfreteint" type="value" col="2" :metadata="metadata.di.vfreteint" :disabled="true"></form-field>
                    <form-field v-model="di.vseguroint" type="value" col="2" :metadata="metadata.di.vseguroint" :disabled="true"></form-field>
                    <form-field v-model="di.vaduaneiro" type="value" col="2" :metadata="metadata.di.vaduaneiro" :disabled="true"></form-field>
                    <form-field v-model="di.freteinclusoad" type="select" col="3" :metadata="metadata.di.freteinclusoad" :disabled="isView"
                        name="freteinclusoad" :v-errors="errors" v-validate="metadata.di.freteinclusoad.validator"></form-field>
                </div>

                <label-title title="Tributos e Taxas"></label-title>
                <div class="row">
                    <form-field v-model="di.taxamoeda" type="value" col="2" :metadata="metadata.di.taxamoeda" :disabled="isView"
                        name="taxamoeda" :v-errors="errors" v-validate="metadata.di.taxamoeda.validator"></form-field>
                    <form-field v-model="di.ratsiscomexdi" type="select" col="2" :metadata="metadata.di.ratsiscomexdi" :disabled="isView"
                        name="ratsiscomexdi" :v-errors="errors" v-validate="metadata.di.ratsiscomexdi.validator"></form-field>
                    <form-field v-model="di.rattaxasdi" type="select" col="2" :metadata="metadata.di.rattaxasdi" :disabled="isView"
                        name="rattaxasdi" :v-errors="errors" v-validate="metadata.di.rattaxasdi.validator"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="di.vsiscomex" type="value" col="2" :metadata="metadata.di.vsiscomex" :disabled="isView" preaddon="R$"
                        name="vsiscomex" :v-errors="errors" v-validate="metadata.di.vsiscomex.validator"></form-field>
                    <form-field v-model="di.vafrmm" type="value" col="2" :metadata="metadata.di.vafrmm" :disabled="isView" preaddon="R$"
                        name="vafrmm" :v-errors="errors" v-validate="metadata.di.vafrmm.validator"></form-field>
                    <form-field v-model="di.vmulta" type="value" col="2" :metadata="metadata.di.vmulta" :disabled="isView" preaddon="R$"
                        name="vmulta" :v-errors="errors" v-validate="metadata.di.vmulta.validator"></form-field>
                    <form-field v-model="di.vacrescimo" type="value" col="2" :metadata="metadata.di.vacrescimo" :disabled="isView" preaddon="R$"
                        name="vacrescimo" :v-errors="errors" v-validate="metadata.di.vacrescimo.validator"></form-field>
                    <form-field v-model="di.vantidumping" type="value" col="2" :metadata="metadata.di.vantidumping" :disabled="isView" preaddon="R$"
                        name="vantidumping" :v-errors="errors" v-validate="metadata.di.vantidumping.validator"></form-field>
                    <form-field v-model="di.vataero" type="value" col="2" :metadata="metadata.di.vataero" :disabled="isView" preaddon="R$"
                        name="vataero" :v-errors="errors" v-validate="metadata.di.vataero.validator"></form-field>
                    <!-- <form-field v-model="di.vdesp" type="value" col="2" :metadata="metadata.di.vdesp" :disabled="isView" preaddon="R$"
                        name="vdesp" :v-errors="errors" v-validate="metadata.di.vdesp.validator"></form-field> -->
                </div>
                <div class="row">
                    <form-field v-model="di.vii" type="value" col="2" :metadata="metadata.di.vii" :disabled="true" preaddon="R$"></form-field>
                    <form-field v-model="di.vipi" type="value" col="2" :metadata="metadata.di.vipi" :disabled="true" preaddon="R$"></form-field>
                    <form-field v-model="di.vpis" type="value" col="2" :metadata="metadata.di.vpis" :disabled="true" preaddon="R$"></form-field>
                    <form-field v-model="di.vcofins" type="value" col="2" :metadata="metadata.di.vcofins" :disabled="true" preaddon="R$"></form-field>
                    <form-field v-model="di.vicm" type="value" col="2" :metadata="metadata.di.vicm" :disabled="true" preaddon="R$"></form-field>
                    <!-- <form-field v-model="di.stpis" type="select2" col="4" :metadata="metadata.di.stpis"
                        name="stpis" :v-errors="errors" v-validate="metadata.di.stpis.validator"
                        :select2="{entity: 'stpiscofins/saidas', minlength: 0}"></form-field>
                    <form-field v-model="di.stcofins" type="select2" col="4" :metadata="metadata.di.stcofins"
                        name="stcofins" :v-errors="errors" v-validate="metadata.di.stcofins.validator"
                        :select2="{entity: 'stpiscofins/saidas', minlength: 0}"></form-field> -->
                </div>

                <label-title title="Valores Calculados"></label-title>
                <div class="row">
                    <form-field v-model="di.viicalc" type="value" col="2" :metadata="metadata.di.viicalc" :disabled="true" preaddon="R$"></form-field>
                    <form-field v-model="di.vipicalc" type="value" col="2" :metadata="metadata.di.vipicalc" :disabled="true" preaddon="R$"></form-field>
                    <form-field v-model="di.vpiscalc" type="value" col="2" :metadata="metadata.di.vpiscalc" :disabled="true" preaddon="R$"></form-field>
                    <form-field v-model="di.vcofinscalc" type="value" col="2" :metadata="metadata.di.vcofinscalc" :disabled="true" preaddon="R$"></form-field>
                    <form-field v-model="di.vicmcalc" type="value" col="2" :metadata="metadata.di.vicmcalc" :disabled="true" preaddon="R$"></form-field>
                    <form-field v-model="di.totalnf" type="value" col="2" :metadata="metadata.di.totalnf" :disabled="true" preaddon="R$"></form-field>
                </div>

                <!-- <div class="col">
                    <alert type="warning" title="Valores de ICMS" :text="valoresDeICMS"></alert>
                </div> -->

                <label-title title="ICMS"></label-title>
                <div class="row">
                    <form-field v-model="di.orimerc" type="select2" col="3" :metadata="metadata.di.orimerc" :disabled="isView"
                        name="orimerc" :v-errors="errors" v-validate="metadata.di.orimerc.validator"></form-field>
                    <form-field v-model="di.sticm" type="select2" col="3" :metadata="metadata.di.sticm" :disabled="isView"
                        name="sticm" :v-errors="errors" v-validate="metadata.di.sticm.validator"></form-field>
                    <form-field v-model="di.aicm" type="value" col="2" :metadata="metadata.di.aicm" :disabled="isView"
                        name="aicm" :v-errors="errors" v-validate="metadata.di.aicm.validator"></form-field>
                    <!-- <form-field v-model="di.ricm" type="value" col="2" :metadata="metadata.di.ricm" :disabled="isView"
                        name="ricm" :v-errors="errors" v-validate="metadata.di.ricm.validator"></form-field> -->
                    <form-field v-model="di.picmdif" type="value" col="2" :metadata="metadata.di.picmdif" :disabled="isView"
                        name="picmdif" :v-errors="errors" v-validate="metadata.di.picmdif.validator"></form-field>
                    <div class="col-2 mt-3">
                        <v-button v-if="!isView" label="Calcular" title="" :nb-btdef="true" @click="handleCalcular"></v-button>
                    </div>
                </div>
            <!-- FIM CAPA DA DI -->
            </div>



            <!-- VISUALIZACAO DAS ADICOES -->
            <div class="default-container mt-3">
                <label-title title="Adições"></label-title>
                <div class="row">
                    <div class="col">
                        <v-button v-if="!isView" label="Informar Alíquotas nas Adições" title="" :nb-btdef="true" @click="editAliquotasAdicoes"></v-button>
                    </div>
                </div>
                <br>
                <div class="mainbox" v-for="(adicao, index) in diad" :key="index">
                    <div class="box">
                        <div class="row">
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.nadicao"></v-label><br>
                                <strong class="data-list">{{ adicao.nadicao }}</strong>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.ncm"></v-label><br>
                                <strong class="data-list">{{ adicao.ncm }}</strong>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.aicm"></v-label><br>
                                <span class="data-list">{{ adicao.aicm | format(2) }}</span>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.picmdif"></v-label><br>
                                <span class="data-list">{{ adicao.picmdif | format(2) }}</span>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.ricm"></v-label><br>
                                <span class="data-list">{{ adicao.ricm | format(2) }}</span>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.mva"></v-label><br>
                                <span class="data-list">{{ adicao.mva | format(2) }}</span>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.vicm"></v-label><br>
                                <span class="data-list">{{ adicao.vicm | format(2) }}</span>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.aii"></v-label><br>
                                <span class="data-list">{{ adicao.aii | format(2) }}</span>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.aipi"></v-label><br>
                                <span class="data-list">{{ adicao.aipi | format(2) }}</span>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.apis"></v-label><br>
                                <span class="data-list">{{ adicao.apis | format(2) }}</span>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diad.acofins"></v-label><br>
                                <span class="data-list">{{ adicao.acofins | format(2) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- FIM ADICOES -->

            <!-- VISUALIZACAO E IDENTIFICACAO DOS ITENS -->
            <div class="default-container mt-3">
                <label-title title="Produtos Importados"></label-title>
                <div class="row">
                    <div class="col">
                        <v-button v-if="!isView" label="Informar Impostos nos Produtos" title="" :nb-btdef="true" @click="editIcms"></v-button>
                    </div>
                </div>
                <br>
                <div class="mainbox-select" v-for="(it, index) in diit" v-bind:key="index">
                    <div v-if="it.stitemdi == '1'" class="mark-red"></div>
                    <div v-if="it.stitemdi == '0'" class="mark-green"></div>
                    <div class="box">
                        <!-- <alert v-if="it.msg" type="danger" :text="it.msg"></alert> -->
                        <div class="row">
                            <div class="col-md-6 col-12 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diit.descricaox"></v-label><br>
                                <label class="data-list">{{ it.descricaox }}</label>
                            </div>
                            <div class="col-md-4 col-12 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diit.qt"></v-label><br>
                                <span class="data-list">{{ it.qt | format(4) }}/{{ it.unidadex }}</span>
                            </div>
                            <div class="col-md-2 col-12 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diit.vlr"></v-label><br>
                                <span class="data-list">{{ it.vlr | format(4) }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <form-field class="my-2 my-md-0" v-model="it.coditem" type="select2" col="6" :metadata="metadata.diit.coditem"
                                name="coditem" :v-errors="errors" v-validate="metadata.diit.coditem.validator"
                                @input="itemChange(index)"></form-field>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diit.coditem"></v-label><br>
                                <span class="data-list">{{ it.coditem }}</span>
                            </div>
                            <div class="col-md-2 col-6 my-2 my-md-0">
                                <v-label class="lbl-edit" :metadata-field="metadata.diit.uni"></v-label><br>
                                <span class="data-list">{{ it.uni }}</span>
                            </div>
                            <form-field v-model="it.qt" type="value" col="2" :metadata="metadata.diit.qt"></form-field>
                        </div>
                    </div>
                </div>
            </div>
            <!-- FIM VISUALIZACAO E ALTERAÇÃO DOS ITENS -->
        </div>


    </div>
</template>



// WEBPACK FOOTER //
// src/forms/nfimport-form.vue